module.exports = __webpack_public_path__ + "static/mw12-88e05d78344af2a2644c23594f0ae541.jpg";